import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    // Public realtor letter page - no SSO (App.vue skips sign-in and the app chrome for this path).
    path: '/RealtorLetter',
    name: 'realtorLetter',
    meta: { title: 'Pre-Approval Letter', public: true },
    component: () => import('../views/RealtorLetterView.vue')
  },
  {
    path: '/',
    name: 'conditions',
    query: { id: '' },
    meta: { title: 'Conditions', subtitle: 'Track Clearing Conditions' },
    component: HomeView
  },
  {
    path: '/DisclosureTracking',
    name: 'disclosuretracking',
    query: { id: '' },
    meta: { title: 'Disclosure Tracking' },
    component: () => import('../views/DisclosureTracking.vue')
  },
  {
    path: '/Documents',
    name: 'documents',
    query: { id: '' },
    meta: { title: 'Documents', subtitle: 'Loan Document Library' },
    component: () => import('../views/DocumentsView.vue')
  },
  {
    path: '/Prequal',
    name: 'prequal',
    query: { id: '' },
    meta: { title: 'Prequal', subtitle: 'Pre-Qualification Letters' },
    component: () => import('../views/PrequalView.vue')
  },
  { 
    path: '/FileManager',
    name: 'filemanager',
    query: { id: '' },
    meta: { title: 'File Manager', subtitle: 'Loan File Storage' },
    component: () => import('../views/FileManagerView.vue')
  },
  {
    path: '/ConsumerPortal',
    name: 'consumerportal',
    query: { id: '', swiftprocessing: '' },
    meta: { title: 'LoanLaunch', subtitle: 'Borrower Portal' },
    component: () => import('../views/ConsumerPortalView.vue')
  },
  {
    path: '/Admin',
    name: 'admin',
    query: { id: '' },
    meta: { title: 'Admin' },
    component: () => import('../views/admin.vue')
  },
  {
    path: '/PostClose',
    name: 'postclose',
    query: { id: '' },
    meta: { title: 'Post Close', subtitle: 'Post-Closing Tracking' },
    component: () => import('../views/PostClose.vue')
  },
  {
    path: '/Duplicate',
    name: 'duplicate',
    query: { id: '' },
    meta: { title: 'Duplicate Loan' },
    component: () => import('../views/DuplicateLoan.vue')
  },
  {
    path: '/LoanTasks',
    name: 'loantasks',
    query: { id: '' },
    meta: { title: 'LoanFlow', subtitle: 'Your Loan, In Motion' },
    component: () => import('../views/InternalTasks.vue')
  },
  {
    path: '/InternalTasks',
    redirect: to => {
      return { path: '/LoanTasks', query: to.query }
    }
  },
  {
    path: '/Closing',
    name: 'closing',
    query: { id: '' },
    meta: { title: 'Closing', subtitle: 'Closing Workspace' },
    component: () => import('../views/ClosingView.vue')
  },
  {
    path: '/PricingEngine',
    name: 'pricingEngine',
    component: () => import('../views/PollyPricerView.vue'),
    meta: { title: 'Pricing Engine', subtitle: 'Polly Pricing & Lock' }
  },
  {
    path: '/Credit',
    name: 'credit',
    query: { id: '' },
    meta: { title: 'Credit', subtitle: 'Credit Reports & Ordering' },
    component: () => import('../views/CreditView.vue')
  },
  {
    path: '/Lock',
    name: 'lock',
    query: { id: '' },
    meta: { title: 'Lock', subtitle: 'Rate Lock & Extensions' },
    component: () => import('../views/LockView.vue')
  },
  {
    // Purchase Agreement Import (9189) - read the open loan's purchase agreement and write its fields
    // into Encompass. Moved here from SwiftProcessingSPA. Open to anyone on the file; only editing the field
    // mapping is Admin. Lazy, so pdf.js only loads for this page.
    path: '/PurchaseAgreement',
    name: 'purchaseagreement',
    query: { id: '' },
    meta: { title: 'Purchase Agreement', subtitle: 'Import Contract Terms' },
    component: () => import('../views/PurchaseAgreementImport.vue')
  },
  {
    path: '/SwiftData',
    name: 'swiftdata',
    query: { id: '' },
    meta: { title: 'SwiftData', subtitle: 'AI Summary Data Points' },
    component: () => import('../views/SwiftData.vue')
  },
  {
    path: '/SwiftAlerts',
    name: 'swiftalerts',
    query: { id: '' },
    meta: { title: 'Alerts', subtitle: 'Loan Alerts' },
    component: () => import('../views/SwiftAlerts.vue')
  },
  {
    path: '/ScenarioManager',
    name: 'scenariomanager',
    query: { id: '' },
    meta: { title: 'Scenario Manager' },
    component: () => import('../views/ScenarioManager.vue')
  },
   {
    path: '/screenshare',
    name: 'screenshare',
    query: { id: '' },
    meta: { title: 'Screen Share' },
    component: () => import('../views/ScreenShare.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router
